module.exports = __webpack_public_path__ + "img/grey_019.3946ba8f.png";